export default {
    approvals: {
        title: "Approvazione",
        error: "Si è verificato un errore"
    },
    delegates: {
        title: "Delegati",
        error: "Si è verificato un errore",
        noDelegates: "Nessun elemento",
        delegateDelete: "Il delegato è stato eliminato",
        confirm: {
            delete: "Eliminare il delegato?"
        },
        delegates: {
            email: "E-mail",
            startDate: "Data di inizio",
            endDate: "Data di fine",
        },
        buttons: {
            add: {
                text: "Aggiungi delegato"
            }
        }
    },
    employees: {
        title: "I miei dipendenti",
        error: "Si è verificato un errore",
        empty: "Nessun dipendente trovato",
        users: {
            name: "Nome",
            email: "E-mail"
        },
        model: {
            search: {
                placeholder: "Ricerca",
            }
        },
        cta: {
            orders: "Carica ordini",
            download: "Scarica gli ordini",
            search: "Ricerca"
        }
    }
}